var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55001 15.5155L18.1885 6.87702C18.3372 6.72819 18.5112 6.65219 18.7105 6.64902C18.9098 6.64585 19.0871 6.72185 19.2423 6.87702C19.3974 7.03219 19.475 7.21035 19.475 7.41152C19.475 7.61285 19.3974 7.7911 19.2423 7.94627L10.1828 17.0213C10.0019 17.2019 9.79101 17.2923 9.55001 17.2923C9.30901 17.2923 9.09809 17.2019 8.91726 17.0213L4.74226 12.8463C4.59359 12.6974 4.52026 12.5208 4.52226 12.3163C4.52409 12.1119 4.60259 11.9322 4.75776 11.777C4.91292 11.6219 5.09109 11.5443 5.29226 11.5443C5.49359 11.5443 5.67184 11.6219 5.82701 11.777L9.55001 15.5155Z",
    fill: "#5950FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckChecked);
export default __webpack_public_path__ + "static/media/check_checked.9d24e812fa974da5642fafff0186d91a.svg";
export { ForwardRef as ReactComponent };